<div class="global-search">
  <i class="bi bi-search gs-icon"></i>
  <input
    type="text"
    class="gs-input"
    placeholder="Search pages & sections..."
    [(ngModel)]="query"
    (input)="onInput()"
    (focus)="onInput()"
    (keydown)="onKeyDown($event)"
    autocomplete="off" />
  <i *ngIf="query" class="bi bi-x-circle gs-clear" (click)="clear()"></i>

  <div class="gs-results" *ngIf="open">
    <div
      *ngFor="let r of results; let i = index"
      class="gs-result"
      [class.active]="i === highlightIndex"
      [class.disabled]="isDisabled(r)"
      [attr.data-kind]="r.kind"
      [attr.title]="isDisabled(r) ? 'Impersonate as a teacher to view this page' : null"
      (mouseenter)="highlightIndex = i"
      (click)="go(r)">
      <div class="gs-result-main">
        <i class="bi" [class.bi-arrow-right-short]="!isDisabled(r)" [class.bi-lock]="isDisabled(r)"></i>
        <span class="gs-result-label">{{ r.label }}</span>
        <span *ngIf="r.kind !== 'page'" class="gs-kind-badge" [attr.data-kind]="r.kind">
          {{ r.kind === 'tab' ? 'Tab' : 'Subtab' }}
        </span>
        <span *ngIf="isDisabled(r)" class="gs-impersonate-badge">Impersonate as teacher</span>
      </div>
      <span class="gs-result-path">{{ r.module }}</span>
    </div>
  </div>
</div>
